import { useEffect, useState } from 'react';

const STORAGE_KEY = 'offer-timer-ends-at';

export type SessionTimer = { minutes: number; seconds: number; ended: boolean };

function readEnd(durationMs: number): number {
  try {
    const stored = Number(window.sessionStorage.getItem(STORAGE_KEY));
    if (stored > 0) return stored;
    const end = Date.now() + durationMs;
    window.sessionStorage.setItem(STORAGE_KEY, String(end));
    return end;
  } catch {
    return Date.now() + durationMs;
  }
}

/** Cuenta regresiva por visita: arranca al entrar y no se reinicia al recargar la página. */
export function useSessionTimer(minutes: number): SessionTimer {
  const [end] = useState(() => (minutes > 0 ? readEnd(minutes * 60_000) : 0));
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!end || Date.now() >= end) return;
    const id = window.setInterval(() => {
      const t = Date.now();
      setNow(t);
      if (t >= end) window.clearInterval(id);
    }, 1000);
    return () => window.clearInterval(id);
  }, [end]);

  const total = Math.max(0, Math.floor((end - now) / 1000));
  return { minutes: Math.floor(total / 60), seconds: total % 60, ended: end > 0 && total === 0 };
}
